const app = {
	product_info: "產品資訊",
	txid: "區塊鏈記錄: ",
	show_info: "更多資訊",
	track_info: "流通資訊",
	meterial_info: "溯源資訊",
	product_head: "產品資訊",
	show_head: "更多資訊",
	track_head: "流通資訊",
	meterial_head: "溯源資訊",

	valid_msg: "Part of the production process has been verified by DNV",
	message_tc_landingpage_NotAllowException: "Please contact your admin to open the access for the information",
	message_tc_landingpage_DataEmptyException: "Fail authentication",
	message_default: "Unreadable product information",
	sorry: "Error",
	download_msg: "You may check the verification information and more details of the product by using VeChain Pro.",
	download: "Download",
	mainnet: "Main",
	testnet: "Sandbox",
	mintText: 'NFT',
	simpleText: '芯片未验证',
	track_info_multi: '个追溯记录',
	track_info_single: '个追溯记录',
	meterial_info_multi: '个溯源记录',
	meterial_info_single: '个溯源记录',
	custom_records_multi: '个记录',
	custom_records_single: '个记录',
	verify: {
		sku: "商品信息验证",
		chip: "芯片防伪验证",
		pass: "已通过",
		fail: "失败",
		view: "查看展示页",
		user: "请联系商家进行人工核查"
	},
	nft: {
		series: 'Series',
		createTime: 'Creation Time',
		owner: 'Owner',
		blockinfo: 'Blockchain Information',
		contractAddress: 'Contract Address'
	}
}

export default {
	app
}
